// Derived series: what an action made from an image (sdk/CONTRACT.md,
// "Derived series"). Each is a series of its own in the image's study — a
// Segmentation (SEG) for masks, a Structured Report (SR) for measurements —
// and QIDO lists it like any other, so every DICOM client can read it. They are
// never images: the viewer's own series lists leave them out, and the AI tab
// shows what they hold.

import { Tag, getString, type DicomJson } from './dicomTags';

/** The modalities of derived series. */
export const DERIVED_MODALITIES: ReadonlySet<string> = new Set(['SEG', 'SR']);

/** Whether a Modality value names a derived series. */
export function isDerivedModality(modality: string | null | undefined): boolean {
  return !!modality && DERIVED_MODALITIES.has(modality.trim().toUpperCase());
}

/** Whether a dataset (a QIDO series row, or an instance's metadata) belongs to a derived series. */
export function isDerivedDataset(ds: DicomJson | undefined): boolean {
  return isDerivedModality(getString(ds, Tag.Modality));
}

/** Only the series that are images. */
export function viewableSeries<S extends { modality: string }>(series: S[]): S[] {
  return series.filter((s) => !isDerivedModality(s.modality));
}
